import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectFloorTypes = createSelector(selectJsonQuery, jsonQuery => getTermsValue('floor_types')(jsonQuery));
